<script>
import { IconTruck, IconRouter, IconAlertTriangleFilled } from "@tabler/icons-vue";

export default {
	name: "DeviceCard",
	components: {IconTruck, IconRouter, IconAlertTriangleFilled},
	props: {
		asset: {
			type: Object,
			required: true,
		},
	},
  computed: {
    getSubHeading(){
      return [
        this.asset.name,
      ].filter(_ => _ !== null).join(' / ');
    },
  },
}
</script>

<template>
  <router-link :to="{name: 'assets.show', params: { asset: asset.id }}">
    <Card :pt="{header: { style: { 'border-bottom': '0px' }}}">
      <template #header>
        <div class="flex p-4 items-center justify-center">
          <IconTruck class="text-primary-900 opacity-50" :size="60"/>
        </div>
      </template>
      <template #subtitle>{{ getSubHeading }}</template>
      <template #content>
        <div class="-mt-7 mb-2">
          <span class="text-sm font-semibold text-blue-600 flex">{{ asset.company?.name ?? $t('common.na') }}</span>
        </div>
      </template>
    </Card>
  </router-link>
</template>

<style scoped>

</style>